import { useEffect, useState } from "react";
import MedicalReviewDetails from "./MedicalReviewDetails";
import "../Page/claimProcessing.scss";
import { getInvestigationTable } from "../Investigation/investigationHelper";
import { INVESTIGATION_TYPES, PAGE_NAME_KEYS } from "../../../../consts";
import { searchClaimProcessing } from "../Service/apiHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const MedicalReviewPage = (props) => {
  const { claimDetails, roleDataCookie, activeTab } = props;
  const [medicalReviewList, setMedicalReviewList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notified, setNotified] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getMedicalReviewList = async () => {
    setLoading(true);
    try {
      const response = await getInvestigationTable( claimDetails?.claimId, INVESTIGATION_TYPES.MEDICAL);
      if (response?.data) {
        setMedicalReviewList(response.data);
      } else {
        setMedicalReviewList([]);
      }
    } catch (error) {
      console.error("Failed to fetch medical review list:", error);
      setMedicalReviewList([]);
    } finally {
      setLoading(false);
    }
  };

 const handleClaimChange = (claimId) => {
    setLoading(true)
    searchClaimProcessing(
      { claimId },
      { size: 10, page: 0 },
      (list) => {
        if (list.length) {
          navigate(
            `/dashboard/${PAGE_NAME_KEYS.HEALTH_CLAIM_PROCESSING}/${PAGE_NAME_KEYS.CLAIM_DETAILS}`, {
            state: {
             ...location.state,
              claimDetails: list[0]
            }
          }
          );
        } else {
          toast.error("Something Went Wrong.")
        }
      }
    );
    setLoading(false)
 
  }

  useEffect(() => {
    if (claimDetails?.claimId && activeTab ==="MEDICAL REVIEW") {
      getMedicalReviewList();
    }
  }, [claimDetails?.claimId, activeTab]);

  useEffect(() => {
    if (notified) {
      getMedicalReviewList();
      setNotified(false);
      handleClaimChange(claimDetails?.claimId)
    }
  }, [notified]);

  return (
    <div className="claim-processing-tabs bg-white">
      <MedicalReviewDetails
        medicalReviewList={medicalReviewList}
        loading={loading}
        claimDetails={claimDetails}
        roleDataCookie={roleDataCookie}
        setNotified={setNotified}
        handleOpenMedicalReviewModal={() => {}}
        activeTab={activeTab}
      />
    </div>
  );
};

export default MedicalReviewPage;


